/**
 * Helper function for loading the official FB Pixel script
 */
const injectScript = () => {
  if (typeof window === 'undefined' || window.fbq) return;

  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];

  const t = document.createElement('script');
  t.async = !0;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(t, s);
};

const ReactPixel = {
  init: (pixelId, advancedMatching = {}, options = { autoConfig: true, debug: false }) => {
    if (typeof window === 'undefined' || !pixelId) return;
    injectScript();
    if (options.debug) {
      console.log(`[FB Pixel] Initialized with ID: ${pixelId}`);
    }

    // set auto config
    if (options.autoConfig === false) {
      window.fbq('set', 'autoConfig', false, pixelId);
    }

    // pixel init
    window.fbq('init', pixelId, advancedMatching);
  },

  pageView: () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
  },

  trackCustom: (event, data) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', event, data);
    }
  },
};

export default ReactPixel;
